import { includes } from 'lodash';
import { BREAKPOINTS } from 'constants/values';

export default {
  data() {
    return {
      display: null,
    };
  },
  computed: {
    showOnMobileAndTablet() {
      return includes(BREAKPOINTS.PHONE_AND_TABLET, this.display);
    },
  },
  methods: {
    detectDisplay() {
      this.display = window.getComputedStyle(document.querySelector('body'), ':before').getPropertyValue('content').replace(/"/g, '');
      this.$emit('display', this.display);
    },
  },
  mounted() {
    this.detectDisplay();
    this.$nextTick(() => {
      window.addEventListener('resize', this.detectDisplay);
    });
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.detectDisplay);
  },
};



// WEBPACK FOOTER //
// ./src/components/mixins/responsive-monitor.js